import { Label, Listbox } from "@headlessui/react";
import { FC, Fragment } from "react";
import { ButtonSelectAvatar } from "../molecules/ButtonSelectAvatar";
import { ListSelectAvatar } from "../molecules/ListSelectAvatar";
import { optionAvatar } from "./SelectAvatar";
import { ButtonMultiSelectAvatar } from "../molecules/ButtonMultiSelectAvatar";
import { ListMultiSelectAvatar } from "../molecules/ListMultiSelectAvatar";

export type MultiSelectAvatarProps = {
  selected: optionAvatar[];
  options: optionAvatar[];
  setSelected: (options: optionAvatar[]) => void;
  tittle: string;
  text_describe?: string;
  labelClassName?: string;
};

export const MultiSelectAvatar: FC<MultiSelectAvatarProps> = ({
  options,
  selected,
  setSelected,
  tittle,
  text_describe,
  labelClassName,
}) => {
  return (
    <Fragment>
      <Listbox value={selected} onChange={setSelected} multiple>
        <div>
        <Label className={`block text-sm font-medium leading-6 text-gray-900 ${labelClassName}`}>
        {tittle}
      </Label>
          <div className="relative">
            <ButtonMultiSelectAvatar selected={selected} />
            <ListMultiSelectAvatar option={options} />
          </div>
          <p className="mt-1 text-sm text-gray-400">{text_describe}</p>
        </div>
      </Listbox>
    </Fragment>
  );
};
